
export const ReminderTypeList = [
  { value: false, label: 'Immediately' },
  { value: true, label: 'Repeating' },
];